module.exports = __webpack_public_path__ + "static/media/tback.cf0498ef.jpg";